import React from 'react';
import PropTypes from 'prop-types';
import Helpers from '../../utils/helpers';
import Choice from '../choice';

class Radio extends React.Component {
    constructor (props) {
        super(props);
        this.uuid = Helpers.getComponentId('Radio');
    }
    render () {
        const {
            label,
            name,
            checked,
            reverse,
            disabled,
            className,
            children,
            value,
            ...otherProps } = this.props;

        return (
            <Choice
                uuid={this.uuid}
                className={className}
                iconSize="0.625em"
                iconType="circle"
                disabled={disabled}
                label={label}
                name={name}
                checked={checked}
                reverse={reverse}
                type="radio"
                value={value}
                useSprite={this.props.useSprite}
                {...otherProps}
            >{children}</Choice>
        );
    }
}

Radio.propTypes = {
    /**
     * property that identifies whether the component is checked, internal use
     * @ignore
     */
    checked: PropTypes.bool,
    /**
     * Children of the radio component
     */
    children: PropTypes.node,
    /**
     * Custom classes to be passed to component
     */
    className: PropTypes.string,
    /**
     * Disables the radio
     */
    disabled: PropTypes.bool,
    /**
     * useSprite option for icon
     */
    useSprite: PropTypes.bool,
    /**
     * Identifier for the component.
     * If not defined the id is generated.
     */
    id: PropTypes.string,
    /**
     * Label for the radio, by default an empty string
     */
    label: PropTypes.string,
    /**
     * name identifier for the radio button, internal use
     * @ignore
     */
    name: PropTypes.string,
    /**
     * Reverse with render the text to the left of the radio
     */
    reverse: PropTypes.bool,
    /**
     * Value of the radio
     */
    value: PropTypes.string.isRequired
};

Radio.defaultProps = {
    checked: false,
    children: null,
    name: '',
    className: '',
    disabled: false,
    useSprite: false,
    id: '',
    label: null,
    reverse: false
};

export default Radio;
